@if (shouldShow) {
  <div
    class="fixed left-0 right-0 z-40 bg-red-500 text-white top-10 lg-custom:top-24 3xl:top-14"
    data-testid="confirmation-banner">
    <div class="relative">
      <div class="py-3 px-4">
        <div class="container mx-auto">
          <div class="flex justify-between items-center">
            <div class="flex items-center space-x-4">
              <!-- Warning Icon -->
              <svg class="h-5 w-5 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                  clip-rule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  fill-rule="evenodd" />
              </svg>
              <div class="flex-1">
                <p class="text-sm md:text-base font-medium">
                  Please check your email to confirm your account. You can continue using {{ brand.productName }}, but
                  some features require account confirmation.
                </p>
                <div class="flex items-center space-x-2 mt-1">
                  <button
                    class="text-sm underline hover:no-underline opacity-90 hover:opacity-100 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
                    [disabled]="isResending()"
                    (click)="resendConfirmationEmail()">
                    @if (isResending()) {
                      <span>Sending...</span>
                    } @else {
                      <span>Resend confirmation email</span>
                    }
                  </button>

                  @if (resendSuccess()) {
                    <span class="text-sm bg-green-600 px-2 py-1 rounded-sm text-white"> Email sent! </span>
                  }

                  @if (resendError()) {
                    <span class="text-sm bg-red-700 px-2 py-1 rounded-sm text-white"> Failed to send </span>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
